<script>
import { Line } from 'vue-chartjs'

function dataHandler (newData, oldData) {
  if (this.$data._chart) {
    this.$data._chart.destroy()
  }
  this.renderChart(this.chartData, this.options)
}

export default {
  extends: Line,
  watch: {
    'chartData': dataHandler
  },
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/results/ResultsChart.vue